<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <g data-follow-fill="currentColor" :fill="_fill">
        <path d="M286.9 900.8c-5.6 0-11.2-1.6-16.1-4.6a30.66 30.66 0 0 1-14.6-26.1v-71.6H102.7c-17 0-30.7-13.7-30.7-30.7v-614c0-17 13.7-30.7 30.7-30.7h818.6c17 0 30.7 13.7 30.7 30.7v614c0 17-13.7 30.7-30.7 30.7H498.8l-198.2 99.1c-4.3 2.1-9 3.2-13.7 3.2zM133.4 737.1h153.5c17 0 30.7 13.7 30.7 30.7v52.6l160.2-80.1c4.3-2.1 9-3.2 13.7-3.2h399.1V184.6H133.4v552.5z" />
        <path d="M307.3 522.3c-17 0-30.7-13.7-30.7-30.7v-61.4c0-17 13.7-30.7 30.7-30.7s30.7 13.7 30.7 30.7v61.4c0 16.9-13.7 30.7-30.7 30.7zm204.7 0c-17 0-30.7-13.7-30.7-30.7v-61.4c0-17 13.7-30.7 30.7-30.7s30.7 13.7 30.7 30.7v61.4c0 16.9-13.7 30.7-30.7 30.7zm204.7 0c-17 0-30.7-13.7-30.7-30.7v-61.4c0-17 13.7-30.7 30.7-30.7s30.7 13.7 30.7 30.7v61.4c0 16.9-13.8 30.7-30.7 30.7z" />
      </g>
    </g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
